import React from 'react';

const LinkTo = ({
  href,
  icon,
  innerText,
  className,
}: {
  href: string;
  icon?: string;
  innerText: string;
  className?: string;
}) => {
  return (
    <a
      className={`border border-accent bg-white px-6 py-3 text-accent inline-flex content-center cursor-pointer hover:bg-accent hover:text-white transition-colors z-10 ${className}`}
      href={href}
    >
      {icon && <i className={`bx ${icon} text-2xl self-center mr-2`} />}
      <p className='self-center'>{innerText}</p>
    </a>
  );
};

export default LinkTo;
